import type { CartItem } from '../store/usePosStore';

export const POS_CART_PERSISTENCE_SCHEMA_VERSION = 1 as const;
export const POS_ACTIVE_DRAFT_TTL_MS = 48 * 60 * 60 * 1000;

export type PosCartPersistenceScope = {
  organizationId: string;
  branchId: string;
  userId: string;
};

export type PosCartPromoSnapshot = {
  appliedPromoCode: string | null;
  selectedCashierPromotionId: string | null;
};

export type PosCartSnapshot = {
  schemaVersion: typeof POS_CART_PERSISTENCE_SCHEMA_VERSION;
  organizationId: string;
  branchId: string;
  userId: string;
  savedAt: string;
  cart: CartItem[];
  promo?: PosCartPromoSnapshot;
};
